import React, { useEffect, useState } from "react";
import { FaFileInvoice } from "react-icons/fa";
import LoadingSpinner from "../LoadingSpinner";
import {getBulkDropdownData, getTextByValueAndKey} from "../../api/keyvalue";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import Button from "../input/Button";
import Grid from "../Grid";
import ButtonRenderer from "../renderer/ButtonRenderer";
import { useSelector } from "react-redux";
import { formatFromJsonDate } from "../../dateConfig";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../renderer/StyleRenderer";
import InfoList from "../InfoList";
import { User } from "react-feather";
import { AUTH_TYPES, FORMS, MODULES } from "../../const";
import Tab from "../Tab";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../hooks/useNextAndPreviousAuthority";
import { checkDuplicate } from "../../api/finance/taxApi";
import {toast} from "react-toastify";
import useUserCompany from "../../hooks/useUserCompany";

const FORM = FORMS.TAX_MANAGER.HEADER.form;

function TaxRegistration({ onSubmit, editMode, initialData }) {
  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Finance,
    section: FORMS.TAX_MANAGER,
  });
  const [drawerTab, setDrawerTab] = useState(firstViableTab);
  const [isLoading, setIsLoading] = useState(false);
  // const [tab, setTab] = useState(firstViableTab);
  const today = new Date().toISOString().split("T")[0]; // Today
  const [taxCode, setTaxCode] = useState("");
  const [taxType, setTaxType] = useState(0);
  const [taxName, setTaxName] = useState("");
  const [taxDescription, setTaxDescription] = useState("");
  const [taxCalc, setTaxCalc] = useState(0);
  const [taxStatus, setTaxStatus] = useState(2);
  const [taxActive, setTaxActive] = useState(1);
  const [taxId, setTaxId] = useState(0);
  const [author, setAuthor] = useState("");
  const [isEntryEdit, setIsEntryEdit] = useState(false);

  const [taxStatusOptions, setTaxStatusOptions] = useState([]);
  const [taxActiveOptions, setTaxActiveOptions] = useState([]);
  const [taxTypeOptions, setTaxTypeOptions] = useState([]);
  const [taxCalcOptions, setTaxCalcOptions] = useState([]);
  const [currentTaxDetail, setCurrentTaxDetail] = useState({
    tadValue: 0,
    tadStart: "",
    tadEnd: "",
    tadStatus: 2,
    tadActive: 1,
  });
  const [gridData, setGridData] = useState([]);
  const [detailCount, setDetailCount] = useState(1);
  const user = useSelector((state) => state.user);
  const [currentErrors, setCurrentErrors] = useState({});
  const [newDetails, setNewDetails] = useState([]);
  const [updatedDetails, setUpdatedDetails] = useState([]);
  const [deletedDetails, setDeletedDetails] = useState([]);
  const [employeeData, setEmployeeData] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const userCompany = useUserCompany();

        const [company, setCompany] = useState(
            userCompany ? userCompany.comId : null
        );

        useEffect(() => {
            setCompany(userCompany ? userCompany.comId : null);
        }, [userCompany]);

  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "taxManeger",
    minTab: 1,
    maxTab: 2,
    module: MODULES.Finance,
    section: FORMS.TAX_MANAGER,
    currentTab: drawerTab,
    authenticated: true,
  });

  useEffect(() => {
    (async () => {
      const {
        status:taxStatusData,
        active: taxActiveData,
        tax_type: typeData,
        tax_calc: taxCalcData
      } = await getBulkDropdownData([
        {key:"tax_type"},
        {key:"tax_calc"},
        {key:"status"},
        {key:"active"},
      ]);
      setTaxTypeOptions(typeData);
      setTaxCalcOptions(taxCalcData);
      setTaxStatusOptions(taxStatusData);
      setTaxActiveOptions(taxActiveData);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      console.log("initial data", initialData);
      if (editMode && initialData) {
        setTaxId(initialData.taxId || 0);
        setTaxCode(initialData.taxCode || "");
        setTaxType(initialData.taxType || 0);
        setTaxName(initialData.taxTax || "");
        setTaxDescription(initialData.taxDescription || "");
        setTaxCalc(initialData.taxCalc || 0);
        setTaxStatus(initialData.taxStatus || 2);
        setTaxActive(initialData.taxActive || 1);

        setEmployeeData((prev) => ({
          ...prev,
          createdBy: initialData.createdBy,
          createdDate: initialData.createdDate,
          lastModifiedBy: initialData.lastModifiedBy,
          lastModifiedDate: initialData.lastModifiedDate,
        }));

        let index = 0;
        const taxDetailsMapped = [];
        for (let taxDetail of initialData.taxDetailsResponses) {
          const statusName = await getTextByValueAndKey(
            "status",
            taxDetail.tadStatus,
          );
          const activeName = await getTextByValueAndKey(
            "active",
            taxDetail.tadActive,
          );
          taxDetailsMapped.push({
            ...taxDetail,
            tempFrom: formatFromJsonDate(taxDetail.tadStart),
            tempTo: formatFromJsonDate(taxDetail.tadEnd),
            tempStatus: statusName,
            tempActive: activeName,
            tempId: index + 1, // Assign tempId for existing details
          });
          index++;
        }
        setGridData(taxDetailsMapped);
        setDetailCount(initialData.taxDetailsResponses.length + 1); // Set detailCount to avoid conflicts with existing tempIds
      }
    })();
  }, [editMode, initialData]);

  console.log("Employee Data", employeeData);

  const handleAddRow = () => {
    setCurrentTaxDetail({
      tadValue: 0,
      tadStart: "",
      tadEnd: "",
      tadStatus: 2,
      tadActive: 1,
    });
  };

  const handleGridChange = (index, field, value) => {
    const newData = [...gridData];
    newData[index][field] = value;
    setGridData(newData);

    if (editMode && newData[index].tadId) {
      setUpdatedDetails((prev) => [...prev, newData[index]]);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!taxType) errors.taxType = "Tax Type is required";
    if (!taxName) errors.taxName = "Tax Name is required";
    if (!taxCalc) errors.taxCalc = "Tax Calculation is required";
    if (!taxStatus) errors.taxStatus = "Tax Status is required";
    if (!taxActive) errors.taxActive = "Tax Active is required";

    // Check for duplicate tax name error
    if (currentErrors.taxName) {
      errors.taxName = currentErrors.taxName; // Retain duplicate error
    }

    setCurrentErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateDetailForm = () => {
    const errors = {};
    if (!currentTaxDetail.tadValue) errors.tadValue = "Value is required";
    if (!currentTaxDetail.tadStart) errors.tadStart = "Start Date is required";
    if (!currentTaxDetail.tadEnd) errors.tadEnd = "End Date is required";
    if (!currentTaxDetail.tadStatus) errors.tadStatus = "Status is required";
    if (!currentTaxDetail.tadActive) errors.tadActive = "Active is required";

    // Prevent past dates for start date
    if (currentTaxDetail.tadStart && currentTaxDetail.tadStart < today) {
      errors.tadStart = "Start Date cannot be before today";
    }

    setCurrentErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = async () => {
    if (validateForm()) {
      try {
        // Check duplicate only if adding OR tax name was modified in edit mode
        const shouldCheckDuplicate =
            !editMode || (editMode && taxName !== initialData?.originalTaxName);

        if (shouldCheckDuplicate) {
          const response = await checkDuplicate(taxName, company);

          if (response === true) {
            setCurrentErrors((prevErrors) => ({
              ...prevErrors,
              taxName: "Tax name already exists",
            }));
            return; // Prevent navigation
          }
        }

        // Passed validation and no duplicate — move to next tab
        setDrawerTab(next());
      } catch (error) {
        console.error("Error checking tax name:", error);
      }
    }
  };

  const handleSaveDetail = async () => {
    // Check for negative tax percentage
    if (currentTaxDetail.tadValue < 0) {
      setCurrentErrors((prevState) => ({
        ...prevState,
        tadValue: "Tax Percentage cannot be negative",
      }));
      return;
    }

    if (validateDetailForm()) {
      // Fetch display values for status and active fields
      const statusName = await getTextByValueAndKey(
        "status",
        currentTaxDetail.tadStatus,
      );
      const activeName = await getTextByValueAndKey(
        "active",
        currentTaxDetail.tadActive,
      );

      const formattedDetail = {
        ...currentTaxDetail,
        tempFrom: formatFromJsonDate(currentTaxDetail.tadStart),
        tempTo: formatFromJsonDate(currentTaxDetail.tadEnd),
        tempStatus: statusName,
        tempActive: activeName,
      };

      setGridData((prevGridData) => {
        let updatedGridData;

        if (isEntryEdit && currentTaxDetail.tadId) {
          // EDIT MODE: Update the specific row being edited
          updatedGridData = prevGridData.map((item) => {
            if (item.tadId === currentTaxDetail.tadId) {
              // Update the matching row
              return {
                ...item,
                ...formattedDetail,
              };
            }
            // If the edited row is set to active, mark others as inactive
            if (formattedDetail.tadActive === 1) {
              return { ...item, tadActive: 2, tempActive: "Deleted" };
            }
            return item;
          });

          // Track the updated detail for API submission
          setUpdatedDetails((prev) =>
            prev.some((detail) => detail.tadId === formattedDetail.tadId)
              ? prev.map((detail) =>
                  detail.tadId === formattedDetail.tadId
                    ? formattedDetail
                    : detail,
                )
              : [...prev, formattedDetail],
          );
        } else if (isEntryEdit && currentTaxDetail.tempId) {
          // EDIT MODE for temporary rows (added but not saved to backend yet)
          updatedGridData = prevGridData.map((item) => {
            if (item.tempId === currentTaxDetail.tempId) {
              // Update the temporary row
              return {
                ...item,
                ...formattedDetail,
              };
            }
            // If the edited row is active, mark others inactive
            if (formattedDetail.tadActive === 1) {
              return { ...item, tadActive: 2, tempActive: "Deleted" };
            }
            return item;
          });

          // Update the new details list
          setNewDetails((prev) =>
            prev.map((detail) =>
              detail.tempId === currentTaxDetail.tempId
                ? formattedDetail
                : detail,
            ),
          );
        } else {
          // ADD MODE: Add a new row
          const newDetail = {
            ...formattedDetail,
            tempId: detailCount, // Assign a unique tempId for new entries
            tadId: null, // Ensure new entries have no tadId
          };

          // If the new row is active, mark others inactive
          updatedGridData = prevGridData.map((item) => ({
            ...item,
            tadActive: 2,
            tempActive: "Deleted",
          }));

          updatedGridData = [newDetail, ...updatedGridData]; // Add the new row to the start
          setNewDetails((prev) => [...prev, newDetail]); // Track new entries
          setDetailCount((prev) => prev + 1); // Increment detail count
        }

        return updatedGridData;
      });

      // Reset the form and exit edit mode
      setCurrentTaxDetail({
        tadValue: 0,
        tadStart: "",
        tadEnd: "",
        tadStatus: 2,
        tadActive: 1,
      });

      setIsEntryEdit(false); // Explicitly exit edit mode
    }
  };

  const handleSubmit = async () => {
    console.log("EditMode: ", editMode, initialData);

    try {
      if (editMode && initialData?.originalTaxName !== initialData?.taxTax) {
        // Step 1: Check for duplicate tax name
        const isDuplicate = await checkDuplicate(taxName, company);

        if (isDuplicate === true) {
          // If duplicate tax name exists, set the error and navigate back to Tab 1
          setCurrentErrors((prevState) => ({
            ...prevState,
            taxName: "Tax name already exists",
          }));
          setDrawerTab(1); // Navigate back to the first tab
          return; // Stop execution if duplicate exists
        }
      }

      // Step 2: Validate the form
      if (!validateForm()) {
        return; // Stop execution if validation fails
      }

      const activeCount = gridData.filter((item) => item.tadActive === 1).length;
      if (activeCount === 0) {
        toast.error("At least one tax detail must be active", {
          containerId: "Main",
          autoClose: 5000,
        });
        return; // Stop submission
      }

      // Step 3: Ensure at least one tax detail is present
      if (gridData.length === 0) {
        setCurrentErrors((prevState) => ({
          ...prevState,
          gridData: "At least one tax detail is required",
        }));
        return;
      }

      // Step 4: Construct the tax request payload
      const taxSetupRequest = {
        taxType,
        taxTax: taxName,
        taxDescription,
        taxCalc,
        taxStatus,
        taxActive,
        author: user.username,
        taxCompany:company,
      };

      const taxDetailsRequests = [
        ...gridData, // Include all grid data (existing + new + updated)
        ...deletedDetails.map((id) => ({ tadId: id, tadStatus: 0 })), // Mark deleted records
      ];

      const taxRequest = {
        taxSetupRequest,
        taxDetailsRequests,
        author: user.username,
      };

      console.log("Submitting taxRequest:", taxRequest); // Log the request before submitting

      // Step 5: Submit the request
      if (editMode) {
        await onSubmit(taxId, taxRequest); // Call onSubmit with taxCode for update
      } else {
        await onSubmit(null, taxRequest); // Call onSubmit without taxCode for add
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleDeleteDetail = (id) => {
    setGridData((prevGridData) =>
        prevGridData.map((item) => {
          const match = item.tempId === id || item.tadId === id;
          if (match) {
            return {
              ...item,
              tadActive: 2, // mark as inactive
              tempActive: "Deleted", // for display in grid
            };
          }
          return item;
        })
    );

    // If item is from backend (has tadId), track as update
    setUpdatedDetails((prev) => {
      const item = gridData.find(
          (d) => d.tempId === id || d.tadId === id
      );
      if (item?.tadId) {
        const alreadyTracked = prev.some((p) => p.tadId === item.tadId);
        if (!alreadyTracked) {
          return [...prev, { ...item, tadActive: 2 }];
        }
      }
      return prev;
    });
  };


  return (
    <>
      <div className="drawer-component">
        <div className="ui top attached tabular menu">
          <Tab
            Icon={FaFileInvoice}
            onClick={() => {
              setDrawerTab(1);
            }}
            active={drawerTab === 1}
            // errors={Object.keys(errorState.employeeErrors).length !== 0}
            label="Tax Registration"
            authenticated={true}
            form={FORMS.TAX_MANAGER.HEADER.form}
            module={MODULES.Finance}
          />
          <Tab
            Icon={FaFileInvoice}
            onClick={() => {
              setDrawerTab(2);
            }}
            active={drawerTab === 2}
            // errors={Object.keys(errorState.employeeErrors).length !== 0}
            label="Tax Details"
            authenticated={true}
            form={FORMS.TAX_MANAGER.DETAILS.form}
            module={MODULES.Finance}
          />
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: drawerTab === 1 ? "block" : "none" }}
        >
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <form className="ui form">
                <div className="four fields">
                  <Input
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_code"}
                    type="text"
                    label="Tax Code"
                    placeholder="Tax Code"
                    disabled={true}
                    value={taxCode}
                  />
                  <Dropdown
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_type"}
                    label="Tax Type"
                    placeholder="Tax Type"
                    required={true}
                    options={taxTypeOptions}
                    value={taxType}
                    onChange={(e, data) => {
                      setTaxType(data.value);
                    }}
                    error={currentErrors.taxType}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { taxType, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_name"}
                    type="text"
                    label="Tax Name"
                    duplicate={false}
                    tableName={"finance.tms_m_tax_setup"}
                    primaryKey={"tax_id"}
                    searchField={"tax_tax"}
                    companyWise={true}
                    companyCol="tax_company"
                    activeCol="tax_active"
                    duplicateErrorMessage={"Duplicate Tax Name"}
                    keyType="S"
                    placeholder="Tax Name"
                    required={true}
                    value={taxName}
                    onChange={(e) => setTaxName(e.target.value)}
                    error={currentErrors.taxName}
                    setErrors={setCurrentErrors}
                    errorField={"taxName"}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { taxName, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={true}
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_calc"}
                    label="Tax Calc"
                    placeholder="Tax Calc"
                    options={taxCalcOptions}
                    style={{ height: "20px" }}
                    value={taxCalc}
                    onChange={(e, data) => {
                      setTaxCalc(data.value);
                    }}
                    error={currentErrors.taxCalc}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { taxCalc, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div className="three fields">
                  <Input
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_description"}
                    type="text"
                    label="Tax Description"
                    placeholder="Tax Description"
                    value={taxDescription}
                    onChange={(e) => setTaxDescription(e.target.value)}
                    error={currentErrors.taxDescription}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { taxDescription, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={false}
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_status"}
                    label="Status"
                    placeholder="Status"
                    options={taxStatusOptions}
                    style={{ height: "20px" }}
                    value={taxStatus}
                    onChange={(e, data) => {
                      setTaxStatus(data.value);
                    }}
                    error={currentErrors.taxStatus}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { taxStatus, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={false}
                    module={MODULES.TaxRegistration}
                    form={FORM}
                    editMode={editMode}
                    field={"tax_active"}
                    label="Active"
                    placeholder="Active"
                    options={taxActiveOptions}
                    style={{ height: "20px" }}
                    value={taxActive}
                    onChange={(e, data) => {
                      setTaxActive(data.value);
                    }}
                    error={currentErrors.taxActive}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { taxActive, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div
                  className="two fields"
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                  }}
                >
                  {/* <Button
                    label={"Next"}
                    module={MODULES.Finance}
                    section={FORMS.TAX_MANAGER}
                    authenticated={true}
                    onClick={handleNext}
                  /> */}
                </div>
              </form>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    template="next"
                    tab={drawerTab + 1}
                    module={MODULES.Finance}
                    section={FORMS.TAX_MANAGER}
                    authenticated={true}
                    onClick={handleNext}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: drawerTab === 2 ? "block" : "none" }}
        >
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <div>
                <form className="ui form">
                  <div className="four fields">
                    <Input
                      type="number"
                      step={0.01}
                      module={MODULES.TaxRegistration}
                      form={FORM}
                      editMode={editMode}
                      field={"tad_percentage"}
                      label="Tax Percentage"
                      required={true}
                      placeholder="Tax Percentage"
                      value={currentTaxDetail.tadValue}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (value >= 0) {
                          setCurrentTaxDetail((prevState) => ({
                            ...prevState,
                            tadValue: value,
                          }));
                          setCurrentErrors((prevState) => {
                            const { tadValue, ...rest } = prevState;
                            return rest;
                          });
                        } else {
                          setCurrentErrors((prevState) => ({
                            ...prevState,
                            tadValue: "Tax Percentage cannot be negative",
                          }));
                        }
                      }}
                      error={currentErrors.tadValue}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { tadValue, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />

                    <Input
                      type="date"
                      module={MODULES.TaxRegistration}
                      form={FORM}
                      editMode={editMode}
                      field={"tad_start"}
                      label="Start Date"
                      required={true}
                      placeholder="Start Date"
                      value={currentTaxDetail.tadStart || ""}
                      onChange={(e) =>
                        setCurrentTaxDetail((prevState) => ({
                          ...prevState,
                          tadStart: e.target.value,
                        }))
                      }
                      error={currentErrors.tadStart}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { tadStart, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Input
                      type="date"
                      module={MODULES.TaxRegistration}
                      form={FORM}
                      editMode={editMode}
                      field={"tad_end"}
                      label="End Date"
                      required={true}
                      placeholder="End Date"
                      value={currentTaxDetail.tadEnd || ""}
                      onChange={(e) =>
                        setCurrentTaxDetail((prevState) => ({
                          ...prevState,
                          tadEnd: e.target.value,
                        }))
                      }
                      error={currentErrors.tadEnd}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { tadEnd, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Dropdown
                      required={false}
                      module={MODULES.TaxRegistration}
                      form={FORM}
                      editMode={editMode}
                      field={"tad_status"}
                      label="Status"
                      placeholder="Status"
                      options={taxStatusOptions}
                      style={{ height: "20px" }}
                      value={currentTaxDetail.tadStatus}
                      onChange={(e, data) => {
                        setCurrentTaxDetail((prevState) => ({
                          ...prevState,
                          tadStatus: data.value,
                        }));
                      }}
                      error={currentErrors.tadStatus}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { tadStatus, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Dropdown
                      required={false}
                      module={MODULES.TaxRegistration}
                      form={FORM}
                      editMode={editMode}
                      field={"tad_active"}
                      label="Active"
                      placeholder="Active"
                      options={taxActiveOptions}
                      style={{ height: "20px" }}
                      value={currentTaxDetail.tadActive}
                      onChange={(e, data) => {
                        setCurrentTaxDetail((prevState) => ({
                          ...prevState,
                          tadActive: data.value,
                        }));
                      }}
                      error={currentErrors.tadActive}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { tadActive, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      justifyContent: "flex-end",
                      gap: "5px",
                    }}
                  >
                    <Button template="reset" onClick={handleAddRow} />
                    <Button
                      template="addOrSave"
                      authenticated={true}
                      editMode={editMode}
                      create={!isEntryEdit == false ? false : true}
                      module={MODULES.Finance}
                      form={FORMS.TAX_MANAGER.DETAILS.form}
                      onClick={handleSaveDetail}
                    />
                  </div>
                </form>
                <Grid
                  content={gridData}
                  config={[
                    {
                      headerName: "Tax Percentage",
                      field: "tadValue",
                      editable: false,
                    },
                    {
                      headerName: "Start Date",
                      field: "tadStart",
                      editable: false,
                      valueGetter: (params) =>
                        params.data.tadStart
                          ? new Date(params.data.tadStart).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              },
                            )
                          : "", // Formats the date to "July 9, 2024"
                    },
                    {
                      headerName: "End Date",
                      field: "tadEnd",
                      editable: false,
                      valueGetter: (params) =>
                        params.data.tadEnd
                          ? new Date(params.data.tadEnd).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              },
                            )
                          : "", // Formats the date to "July 9, 2024"
                    },
                    {
                      headerName: "Status",
                      field: "tempStatus",
                      editable: false,
                      cellRenderer: StatusCellStyle,
                    },
                    {
                      headerName: "Active",
                      field: "tempActive",
                      editable: false,
                      cellRenderer: ActiveCellStyle,
                    },
                    {
                      headerName: "Edit",
                      editable: false,
                      cellRenderer: ButtonRenderer,
                      cellRendererParams: (params) => ({
                        consider: AUTH_TYPES.CREATE,
                        clickHandler: () => {
                          console.log("Params: ", params.data);
                          setIsEntryEdit(true);
                          // Ensure start and end dates are in the correct format
                          const rawStartDate = new Date(params.data.tadStart)
                            .toISOString()
                            .split("T")[0];
                          const rawEndDate = new Date(params.data.tadEnd)
                            .toISOString()
                            .split("T")[0];

                          setCurrentTaxDetail({
                            ...params.data,
                            tadStart: rawStartDate, // Correctly formatted start date
                            tadEnd: rawEndDate, // Correctly formatted end date
                          });
                        },
                        label: "Edit",
                        authenticated: true,
                        editable: false,
                        form: FORMS.TAX_MANAGER.DETAILS.form,
                        module: MODULES.Finance,
                        editMode: editMode,
                      }),
                    },
                    {
                      headerName: "Delete",

                      cellRenderer: ButtonRenderer,
                      cellRendererParams: (params) => ({
                        consider: AUTH_TYPES.CREATE,
                        clickHandler: () => {
                          handleDeleteDetail(
                            params.data.tempId ?? params.data.tadId,
                          );
                        },
                        label: "Delete",
                        className: "ui red button",
                        authenticated: true,
                        form: FORMS.TAX_MANAGER.DETAILS.form,
                        module: MODULES.Finance,
                        editMode: editMode,
                      }),
                    },
                  ]}
                  editable={false}
                  pagination={false}
                  rowHeight={35}
                />
              </div>
              <div
                className="two fields"
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                {/* <Button
                  type="submit"
                  template={editMode ? "update" : "create"}
                  label={editMode ? "Update" : "Submit"}
                  onClick={handleSubmit}
                  form={FORMS.TAX_MANAGER.HEADER.form}
                  module={MODULES.Finance}
                  authenticated={true}
                  editMode={editMode}
                /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    type="submit"
                    template={editMode ? "update" : "create"}
                    isLoading={isSubmitLoading}
                    label={editMode ? "Update" : "Submit"}
                    onClick={handleSubmit}
                    form={FORMS.TAX_MANAGER.HEADER.form}
                    module={MODULES.Finance}
                    authenticated={true}
                    editMode={editMode}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        {editMode && (
          <InfoList
            title="User Information"
            content={[
              {
                title: "Created By",
                value: employeeData.createdBy ? employeeData.createdBy : "N/A",
              },
              {
                title: "Created Date",
                value: employeeData.createdDate
                  ? formatFromJsonDate(employeeData.createdDate)
                  : "N/A",
              },
              {
                title: "Last Modified By",
                value: employeeData.lastModifiedBy
                  ? employeeData.lastModifiedBy
                  : "N/A",
              },
              {
                title: "Last Modified Date",
                value: employeeData.lastModifiedDate
                  ? formatFromJsonDate(employeeData.lastModifiedDate)
                  : "N/A",
              },
            ]}
            Icon={User}
          />
        )}
      </div>
    </>
  );
}

export default TaxRegistration;
